// One-click clean print layout of the selected month's schedule.
// Opens a new window with the official-styled table and triggers the browser print dialog.
import { buildTableHtml } from "./pdfExport";
import { MONTHS_HI } from "../data/rssbData";

export function printSchedule(variant, dates, year, month) {
  const html = buildTableHtml(variant, dates, year, month);
  const w = window.open("", "_blank", "width=1200,height=800");
  if (!w) return false;
  w.document.write(`<!doctype html><html lang="hi"><head>
    <meta charset="utf-8"/>
    <title>RSSB सत्संग प्रोग्राम ${MONTHS_HI[month]} ${year}</title>
    <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700;800&family=Noto+Serif+Devanagari:wght@600;700;800&display=swap" rel="stylesheet"/>
    <style>
      @page { size: A4 landscape; margin: 8mm; }
      html,body { margin:0; padding:0; background:#fff; }
      @media print { .no-print { display:none !important; } }
      .toolbar { position:sticky; top:0; background:#431010; color:#fff; padding:10px 16px; font-family:'Noto Sans Devanagari',sans-serif; display:flex; gap:12px; align-items:center; }
      .toolbar button { background:#6e1b1b; color:#fbf6ea; border:0; padding:8px 16px; border-radius:6px; font-weight:700; cursor:pointer; font-size:14px; }
    </style>
  </head><body>
    <div class="toolbar no-print">
      <span>प्रिंट पूर्वावलोकन — ${MONTHS_HI[month]} ${year}</span>
      <button onclick="window.print()">🖨 प्रिंट करें / Print</button>
      <button onclick="window.close()">बंद करें</button>
    </div>
    ${html}
  </body></html>`);
  w.document.close();
  // give fonts a moment to load before auto-opening the print dialog
  setTimeout(() => {
    try { w.focus(); w.print(); } catch (e) {}
  }, 700);
  return true;
}
